import "./src/styles/tailwind.css";
import "./src/styles/brand.css";
import { trackOutboundClick } from "./src/utils/outbound-analytics";

export const onClientEntry = () => {
  document.addEventListener("click", (event) => {
    trackOutboundClick(event, window.location, window.gtag);
  });
};
